import { MutationTree, GetterTree, Module, ActionTree } from "vuex";
import { GlobalState } from "./state";
import { httpByCurrentCustomer } from "@/lib/client";
import { handleStoreError } from "@/lib/error";

export type UserState = {
  users: OrejasUser[];
  np?: string;
};

export type OrejasUser = {
  id: number;
  email: string;
  name: string;
  uid?: string;
  active: boolean;
  customerCurrent: RoleCustomer;
  customers: RoleCustomer[];
};
export type RoleCustomer = {
  id: number;
  userId: number;
  customerId: number;
  customerName: string;
  role: Role;
};

export const availableRoles = {
  superAdmin: "Administrador",
  customerAdmin: "Admin Cliente",
  customerUser: "Usuario Cliente",
} as const;

export type Role = keyof typeof availableRoles;

const mutations: MutationTree<UserState> = {
  ADD_USERS(state, users: OrejasUser[]) {
    for (let index = 0; index < users.length; index++) {
      const user = users[index];
      if (user.customers.length > 0) {
        user.customerCurrent = user.customers[0];
      }
    }
    state.users = state.users.concat(users);
  },
  REPLACE_USER(state, user: OrejasUser) {
    const idx = state.users.findIndex((u) => u.uid === user.uid);
    if (idx == -1) {
      return;
    }
    if (user.customers.length > 0) {
      user.customerCurrent = user.customers[0];
    }
    state.users.splice(idx, 1, user);
  },
  SET_USERS(state, users: OrejasUser[]) {
    for (let index = 0; index < users.length; index++) {
      const user = users[index];
      if (user.customers.length > 0) {
        user.customerCurrent = user.customers[0];
      }
    }
    state.users = users;
  },
};

const getters: GetterTree<UserState, GlobalState> = {
  moreUsersAvailable(state) {
    return !!state.np;
  },
};

const actions: ActionTree<UserState, GlobalState> = {
  async listUsers({ commit }) {
    const users = await httpByCurrentCustomer().get("users").json<OrejasUser>();
    commit("SET_USERS", users);
  },
  async createUser({ commit }, payload: OrejasUser) {
    const newUser = await httpByCurrentCustomer()
      .post("users", { json: payload })
      .json<OrejasUser>()
      .catch(handleStoreError(undefined, true));
    commit("ADD_USERS", [newUser]);
  },
  async updateUser({ commit }, user: OrejasUser) {
    const newUser = await httpByCurrentCustomer()
      .put(`users`, { json: user })
      .json<OrejasUser>()
      .catch(handleStoreError(undefined, true));
    commit("REPLACE_USER", newUser);
  },
  disableUser({ dispatch }, uid: string) {
    return httpByCurrentCustomer()
      .put(`users/${uid}/inactive`)
      .then(() => {
        dispatch("listUsers");
      })
      .catch(handleStoreError({ name: "users/disableUsers", payload: uid }));
  },
  enableUser({ dispatch }, uid: string) {
    return httpByCurrentCustomer()
      .put(`users/${uid}/active`)
      .then(() => {
        dispatch("listUsers");
      })
      .catch(handleStoreError({ name: "users/disableUsers", payload: uid }));
  },
};

const userModule: Module<UserState, GlobalState> = {
  state: {
    users: [],
    np: undefined,
  },
  mutations,
  getters,
  actions,
  namespaced: true,
};

export default userModule;
